type Props = {
  text: string
  clazz?: string,
  cssStyles?: string,
};

function SectionTitle({text, clazz = 'text-xl md:text-2xl', cssStyles = ''}: Props) {
    return (
        <h3 className={`font-sans font-medium ${clazz} text-slate-600 ${cssStyles}`}>
            {text}
        </h3>
    );
}

export default SectionTitle;